import baseTime, { TBaseTime } from './baseTime'

type WeekValue = number
type DayValue =
 | 'Sunday'
 | 'Monday'
 | 'Tuesday'
 | 'Wednesday'
 | 'Thursday'
 | 'Friday'
 | 'Saturday'

const WEEKDAY_MAP: Record<DayValue, number> = {
 Sunday: 0,
 Monday: 1,
 Tuesday: 2,
 Wednesday: 3,
 Thursday: 4,
 Friday: 5,
 Saturday: 6,
}

const NUMBER_TO_WEEKDAY = Object.entries(WEEKDAY_MAP).reduce(
 (acc, [key, value]) => {
  acc[value] = key as DayValue
  return acc
 },
 {} as Record<number, DayValue>,
)

// 1. ✅ Get Nth or Last Weekday of Current Month
export function getWeekdayOfCurrentMonth(
 weekValue: WeekValue,
 dayValue: DayValue,
): baseTime.Moment | null {
 //  const targetDay = WEEKDAY_MAP[weekday]
 const today = baseTime()

 let targetDate = getDateFromMonth(today, weekValue, dayValue)
 if (targetDate.isBefore(today, 'day')) {
  const nextMonth = today.clone().add(1, 'month')
  targetDate = getDateFromMonth(nextMonth, weekValue, dayValue)
 }

 return targetDate

 //  return null
}

function getDateFromMonth(
 baseDate: TBaseTime,
 weekValue: WeekValue,
 dayValue: DayValue,
): TBaseTime {
 const year = baseDate.year()
 const month = baseDate.month() // 0-based
 const dayIndex = baseTime().day(dayValue).day() // "Tuesday" → 2

 if (weekValue === 5) {
  // Last occurrence of the weekday in the month
  const lastDayOfMonth = baseTime([year, month]).endOf('month')
  let lastWeekday = lastDayOfMonth.day(dayIndex)

  if (lastWeekday.month() !== month) {
   lastWeekday = lastWeekday.subtract(7, 'days')
  }

  return lastWeekday
 }
 // First to Fourth week
 const firstDayOfMonth = baseTime([year, month]).startOf('month')
 const weekday = firstDayOfMonth.day(dayIndex)

 if (weekday.month() !== month) {
  weekday.add(7, 'days')
 }

 return weekday.add((weekValue - 1) * 7, 'days')
}

export const getWeekDayFromDate = (input?: baseTime.Moment) => {
 const date = baseTime(input)
 const targetDay = date.day()
 const weekday = NUMBER_TO_WEEKDAY[targetDay]
 return weekday
}

export function getWeekdayPositionFromDate(input: baseTime.Moment | string): {
 weekday: DayValue
 weekNumber: WeekValue
} {
 const date = baseTime(input)
 const targetDay = date.day()
 const weekday = NUMBER_TO_WEEKDAY[targetDay]

 // Count how many times this weekday occurred up to this date
 let count = 0
 let current = date.clone().startOf('month')

 while (current.isBefore(date) || current.isSame(date, 'day')) {
  if (current.day() === targetDay) {
   count++
  }
  current = current.add(1, 'day')
 }

 // Clone before mutating to prevent changing the original date
 const temp = date.clone().add(1, 'week')
 const isLast = temp.month() !== date.month() && temp.day() === targetDay

 const weekNumber: WeekValue = isLast ? 5 : (count as WeekValue)
 return { weekday, weekNumber }
}
